import React from 'react'
import { Setting } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ButtonMenu from '@SonarCX/components/molecules/ButtonMenu2'

import { toTitleCase } from '@SonarCX/utilities'
import { useTaskCardState } from '@SonarCX/providers/TaskCardStateProvider'
import useStyles from './styles'

const ColumnType: React.FC = () => {
  const theme = useTheme()

  const { filterID, setFilterID } = useTaskCardState()

  const classes = useStyles()

  const options = React.useMemo(() => {
    const opts: (keyof LocalTask)[] = []
    opts.push('category_id', 'priority_id', 'status_id', 'type_id', 'team_id')
    return opts
  }, [])

  const renderOption = React.useCallback((id: keyof LocalTask) => {
    const name = toTitleCase(id.split('_')[0])
    return name
  }, [])

  const handleSelect = React.useCallback(
    (id: keyof LocalTask) => {
      setFilterID(id)
    },
    [setFilterID]
  )

  return (
    // @ts-ignore
    <ButtonMenu
      selected={filterID}
      options={options}
      renderOption={renderOption}
      onSelect={handleSelect}
      className={classes.menu}
    >
      <div className={classes.root}>
        <div className='icon'>
          <Setting size={theme.size.base} />
        </div>

        <div className='text'>{renderOption(filterID).toLocaleUpperCase()}</div>
      </div>
    </ButtonMenu>
  )
}

export default ColumnType
